import { CallableInput } from "Components/Shared";
import AccountSelect from "Components/Shared/AccountSelect";
import BTExportType from "Components/Shared/BTExportType";
import CallableTextArea from "Components/Shared/CallableTextArea";
import DateTimePicker from "Components/Shared/DateTimePicker";
import NumberExportType from "Components/Shared/NumberExportType";
import { Field, Formik } from "formik";
import { useAccount, useTicket } from "Hooks/Endpoints";
import React from "react";
import {
  Button,
  Container,
  Dimmer,
  Form,
  Icon,
  Loader,
  Menu,
  Segment,
} from "semantic-ui-react";
import * as yup from "yup";

const validation = yup.object().shape({
  customer: yup.object().required(),
  ddi: yup.string().required(),
  exportType: yup.string().required(),
  portalReference: yup.string().required(),
  postalCode: yup.string().required(),
  requiredDate: yup.string().required(),
  cancelDate: yup.string().required(),
  status: yup.string().required(),
});

type ExportNumberFormProps = {
  onBack: Function;
};

const ExportNumberForm = ({ onBack }: ExportNumberFormProps) => {
  const { listAccounts } = useAccount();

  const { saveExportRequest, loading } = useTicket();

  const initValues = {};

  return (
    <Container>
      <Dimmer active={loading} inverted>
        <Loader inverted />
      </Dimmer>

      <Menu fluid stackable>
        <Menu.Item header onClick={() => onBack()}>
          <Icon name='x' />
        </Menu.Item>
        <Menu.Item header>Number Allocation Request</Menu.Item>
      </Menu>
      <Segment>
        <Formik
          initialValues={initValues}
          onSubmit={(values) => {
            saveExportRequest(values);
            setTimeout(() => onBack(), 1000);
          }}
          validationSchema={validation}
          render={({ handleSubmit, isValid, errors }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <AccountSelect
                  accounts={listAccounts}
                  name='customer'
                  label='Select Account'
                />

                <Field
                  name='ddi'
                  label='DDI to export'
                  component={CallableInput}
                />

                <Field
                  name='associatedNumbers'
                  label='Associated Numbers'
                  placeholder='N/A'
                  component={CallableTextArea}
                />

                <BTExportType name='exportType' label='BT Export Type' />

                <NumberExportType name='portType' label='Export Line Type' />

                <Field
                  name='portalReference'
                  label='Reference'
                  component={CallableInput}
                />

                <Field
                  name='postalCode'
                  label='Post Code'
                  component={CallableInput}
                />

                <DateTimePicker name='requiredDate' label='Required Date' />

                <DateTimePicker name='cancelDate' label='Cancel By Date' />

                <Field name='status' label='Status' component={CallableInput} />

                <Button primary disabled={!isValid}>
                  Submit
                </Button>
              </Form>
            );
          }}
        />
      </Segment>
    </Container>
  );
};

export default ExportNumberForm;
